import React, { useState, useEffect } from "react";
import api from "../services/api.tsx";
import { useAuth } from "../contexts/AuthContext.tsx";
import { useNavigate } from "react-router-dom";
import { useError } from "../contexts/ErrorContext.tsx";
import { useSuccess } from "../contexts/SuccessContext.tsx";

const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { login, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const { setError } = useError();
  const { setSuccess } = useSuccess();

    // Redirect if already logged in
    useEffect(() => {
        if (isAuthenticated) {
        navigate("/"); // Redirect to home page or another page
        }
    }, [isAuthenticated, navigate]);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const res = await api.post("/api/auth/login", {
        email,
        password,
      });

      localStorage.setItem("access_token", res.data.token);
      localStorage.setItem("refresh_token", res.data.refreshToken);
      setSuccess("Giriş başarılı!");
      login(res.data.token);
      navigate("/");
    } catch (error) {
      setError(error.response?.data?.Message || "Bir hata oluştu.");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <form onSubmit={handleLogin} className="bg-white p-8 rounded shadow-md w-80">
        <h2 className="text-2xl font-bold mb-6 text-center">Giriş Yap</h2>
        <input
          type="email"
          className="w-full mb-4 p-2 border rounded"
          placeholder="E-posta"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <input
          type="password"
          className="w-full mb-4 p-2 border rounded"
          placeholder="Şifre"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button className="bg-blue-500 text-white w-full p-2 rounded hover:bg-blue-600">
          Giriş Yap
        </button>
      </form>
    </div>
  );
};

export default LoginPage;